import styled, { css } from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 40px;

  display: grid;
  align-items: center;

  ${({ theme }) => css`
    column-gap: ${theme.padding.small};
    padding: 0 ${theme.padding.input};
    h5 {
      color: ${theme.colors.lightGrey.main};
    }
  `}
`;

interface Props {
  headers: string[];
  gridTemplate: string;
}

export const ListHeader = ({ gridTemplate, headers }: Props) => {
  return (
    <Container style={{ gridTemplateColumns: gridTemplate }}>
      {headers.map((headerTitle, index) => (
        <h5 key={`list-${headerTitle}-${index.toString()}`}>{headerTitle}</h5>
      ))}
    </Container>
  );
};
